﻿import { NgModule,NO_ERRORS_SCHEMA,CUSTOM_ELEMENTS_SCHEMA } from "@angular/core";
import { HashLocationStrategy, Location, LocationStrategy, CommonModule } from "@angular/common";
import { FormsModule } from "@angular/forms";
import { RouterModule } from "@angular/router";
import { UiSwitchModule } from "angular2-ui-switch";
//import { NG2DataTableModule } from "angular2-datatable";
import { NG2DataTableModule } from "angular2-datatable-pagination";
import { NguiAutoCompleteModule } from "@ngui/auto-complete";
import { CalendarModule, CalendarNativeDateFormatter, CalendarDateFormatter,DateFormatterParams,DateAdapter  } from "angular-calendar";
import { adapterFactory } from 'angular-calendar/date-adapters/date-fns';
import { MultiselectDropdownModule } from "angular-2-dropdown-multiselect";

import { SharedModule } from "../shared/shared.module";
import { LoginModule} from "../login/login.module";


import { SearchCasesFilterPipe } from "../pipes/searchCases-filter.pipe";
import { DataFilterPipe } from "../pipes/data-filter.pipe";
import { FormatDateTimePipe } from "../pipes/formatDateTime.pipe";
import { DocumentHistoryFilterPipe } from "../pipes/documentHistory-filter.pipe";
import { RelatedPersonFilterPipe } from "../pipes/relatedperson-filter.pipe";

import { CaseDetailMainComponent } from "./caseDetailMain.component";
import { FutureHearingComponent } from "../cases/futureHearing.component";
import { CasesComponent } from "../cases/mycases.component";

import { ExternalUserFutureHearingComponent } from "../cases/externalUserfutureHearing.component";
import { ExternalUserCasesComponent } from "../cases/externalUserCases.component";

import { UploadDocumentComponent } from "../cases/uploaddocument.component";
import { MyWorkComponent } from "./myWork.component";
import { CalendarComponent } from "../calendar/calendar.component";
import { SearchCasesComponent } from "../cases/searchCases.component";
import { DocumentHistoryComponent } from "../document/documentHistory.component";
import { DocumentNotificationComponent } from "../document/documentNotification.component";
import { SearchCalendarComponent } from "../calendar/searchCalendar.component";
import { PersonInformationComponent } from "../casedetail/personInformation.component";
import { RelatedPersoncomponent } from "../casedetail/relatedPerson.component";
import { Probationcomponent } from "../casedetail/probation.component";
import { DetentionHistoryComponent } from "../casedetail/detentionHistory.component";
import { WarrantHistoryComponent } from "../casedetail/warrantHistory.component";
import { HomeDetentionHistoryComponent } from "../casedetail/homeDetentionHistory.component";
import { PlacementHistoryComponent } from "../casedetail/placementHistory.component";
import { CaseOverviewComponent } from "../casedetail/caseOverview.component";
import { CaseCalendarComponent } from "../casedetail/caseCalendar.component";
import { ReferalHistorycomponent } from "../casedetail/referalHistory.component";
import { PetitionHistorycomponent } from "../casedetail/petitionHistory.component";
import { ObligationsComponent } from "../casedetail/obligations.component";
import { DocketsComponent } from "../dockets/dockets.component";
import { Siblingcomponent } from "../casedetail/sibling.component";
import { CourtReportsComponent } from "../dockets/courtReports.component";
import { JudicialDocumentReportComponent } from "../reports/judicialdocumentreport.component";
import { BlockCaseComponent } from "../admin/blockcase.component";
import { AuthenticationGuard, StaffAuthGuard, AllAuthGuard } from "../guards/auth.guard";
import { RemovalRequestComponent } from "../removalrequest/removalrequest.component";
import { CreateRemovalRequestComponent } from "../removalrequest/createremovalrequest.component";
import { MyProfileComponent } from "../myprofile/myprofile.component";
import { ResetPasswordComponent } from "../login/resetPassword/resetPassword.component";
import { ParentProfileComponent } from "../myprofile/parentprofile.component";

export class CustomDateFormatter extends CalendarNativeDateFormatter {
    
    public dayViewHour({date, locale}: DateFormatterParams): string {
        return new Intl.DateTimeFormat("ca", {
            hour: "numeric",
            minute: "numeric"
        }).format(date);
    }

}


export let casesRoutes = [
    {
        path: "mywork", component: MyWorkComponent, canActivate: [AuthenticationGuard, AllAuthGuard], children: [
            { path: "futurehearing", component: FutureHearingComponent, canActivate: [AuthenticationGuard, StaffAuthGuard] },
            { path: "mycases", component: CasesComponent, canActivate: [AuthenticationGuard, StaffAuthGuard]},
            { path: "uploaddocument", component: UploadDocumentComponent, canActivate: [AuthenticationGuard, StaffAuthGuard] },
            { path: "externaluserfuturehearing", component: FutureHearingComponent, canActivate: [AuthenticationGuard, AllAuthGuard] },
            { path: "externalusercases", component: CasesComponent, canActivate: [AuthenticationGuard, AllAuthGuard ] }
        ]
    },
    {
        path: "searchcase", component: SearchCasesComponent, canActivate: [AuthenticationGuard,StaffAuthGuard]
    },
    {
        path: "notification", component: DocumentNotificationComponent, canActivate: [AuthenticationGuard,AllAuthGuard]
    },
    {
        path: "searchcalendar", component: SearchCalendarComponent, canActivate: [AuthenticationGuard,StaffAuthGuard]
    },
    {
        path: "reports", component: JudicialDocumentReportComponent, canActivate: [AuthenticationGuard, StaffAuthGuard]
    },
    {
        path: "admin", component: BlockCaseComponent, canActivate: [AuthenticationGuard, StaffAuthGuard]
    },
    {
        path: "removalrequest", component: RemovalRequestComponent, canActivate: [AuthenticationGuard, StaffAuthGuard]
    },
    {
        path: "mysettings", component: MyProfileComponent, canActivate: [AuthenticationGuard, StaffAuthGuard]
    },
    {
        path: "parentprofile", component: ParentProfileComponent, canActivate: [AuthenticationGuard, AllAuthGuard]
    },
    {
        path: "createremovalrequest",
        component: CreateRemovalRequestComponent,
        canActivate: [AuthenticationGuard, StaffAuthGuard]
    }
];

@NgModule({
    imports: [UiSwitchModule, NguiAutoCompleteModule,CalendarModule.forRoot({
        provide: DateAdapter,
        useFactory: adapterFactory
      }), CommonModule, FormsModule, RouterModule,  NG2DataTableModule, MultiselectDropdownModule,SharedModule, LoginModule],
    declarations: [CasesComponent, ExternalUserCasesComponent, CaseDetailMainComponent, FutureHearingComponent, ExternalUserFutureHearingComponent, MyWorkComponent, UploadDocumentComponent, SearchCasesComponent, SearchCasesFilterPipe, DataFilterPipe, FormatDateTimePipe, DocumentHistoryFilterPipe, DocumentHistoryComponent, SearchCalendarComponent, DocumentNotificationComponent, CalendarComponent, PersonInformationComponent, RelatedPersoncomponent, Probationcomponent, DetentionHistoryComponent, WarrantHistoryComponent, PetitionHistorycomponent, ReferalHistorycomponent, HomeDetentionHistoryComponent, PlacementHistoryComponent, CaseOverviewComponent, CaseCalendarComponent, ObligationsComponent, Siblingcomponent, DocketsComponent, CourtReportsComponent, JudicialDocumentReportComponent, RemovalRequestComponent, CreateRemovalRequestComponent, BlockCaseComponent, MyProfileComponent,  ParentProfileComponent, RelatedPersonFilterPipe],
    exports: [CasesComponent, ExternalUserCasesComponent, CaseDetailMainComponent, FutureHearingComponent, ExternalUserFutureHearingComponent, MyWorkComponent, UploadDocumentComponent, SearchCasesComponent, SearchCasesFilterPipe, DataFilterPipe, FormatDateTimePipe, DocumentHistoryFilterPipe, DocumentHistoryComponent, SearchCalendarComponent, DocumentNotificationComponent, CalendarComponent, PersonInformationComponent, RelatedPersoncomponent, Probationcomponent, DetentionHistoryComponent, WarrantHistoryComponent, PetitionHistorycomponent, ReferalHistorycomponent, HomeDetentionHistoryComponent, PlacementHistoryComponent, CaseOverviewComponent, CaseCalendarComponent, ObligationsComponent, Siblingcomponent, DocketsComponent, CourtReportsComponent, JudicialDocumentReportComponent, RemovalRequestComponent, CreateRemovalRequestComponent, BlockCaseComponent, MyProfileComponent, ParentProfileComponent, RelatedPersonFilterPipe],
    providers: [AuthenticationGuard,StaffAuthGuard, AllAuthGuard],
    schemas:[NO_ERRORS_SCHEMA,CUSTOM_ELEMENTS_SCHEMA]
})
export class CasesModule { }